'use strict'

module.exports = thematicBreak

function thematicBreak(h, node) {
  return h(node, 'thematicBreak')
}
